import LoadingAnimation from "../loader/loading-animation"

export enum EButtonTypes {
  WHITE = 'cta-white',
  BLUE = 'cta-blue',
  GREY = 'cta-grey',
  DARK = 'cta-dark',
  RED = 'cta-red',
  TAG = 'cta-tag',
  SILVER = 'cta-silver',
  LIGHTSILVER = 'cta-light-silver',
}

export interface IButtonProps {
  children: JSX.Element
  type: EButtonTypes
  className?: string
  isDisabled?: boolean
  isLoading?: boolean
  onClick?: (e: any) => void
}

export default function Button({
  children,
  type,
  className,
  isDisabled,
  isLoading,
  onClick,
}: IButtonProps) {
  return (
    <button
      className={`cta-button ${className ?? ''} ${type}`}
      style={{ pointerEvents: isDisabled ? 'none' : 'inherit' }}
      onClick={onClick}
      disabled={isDisabled}
    >
      {isLoading ? <LoadingAnimation /> : children}
    </button>
  )
}
